import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './cards/dashboard-glass.css';
import './BottomNavigation.css';

export interface NavItem {
  id: string;
  label: string;
  icon: string;
  path: string;
  dashboardTab?: string;
  badge?: number;
  onClick?: () => void;
}

const defaultNavItems: NavItem[] = [
  {
    id: 'main',
    label: 'Главная',
    icon: 'ri-home-line',
    path: '/dashboard',
    dashboardTab: 'main'
  },
  {
    id: 'sessions',
    label: 'Смены',
    icon: 'ri-time-line',
    path: '/dashboard',
    dashboardTab: 'sessions'
  },
  {
    id: 'company',
    label: 'Компания',
    icon: 'ri-building-line',
    path: '/dashboard',
    dashboardTab: 'company'
  },
  {
    id: 'finance',
    label: 'Обзор',
    icon: 'ri-line-chart-line',
    path: '/dashboard',
    dashboardTab: 'finance'
  },
  {
    id: 'profile',
    label: 'Профиль',
    icon: 'ri-user-line',
    path: '/dashboard',
    dashboardTab: 'profile'
  }
];

interface BottomNavigationProps {
  className?: string;
  onTabChange?: (tab: string) => void;
  items?: NavItem[];
  activeTab?: string;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ 
  className = '',
  onTabChange,
  items,
  activeTab
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = items || defaultNavItems;

  const handleNavClick = (item: NavItem) => {
    // Если есть кастомный обработчик, используем его
    if (item.onClick) {
      item.onClick();
      return;
    }

    if (item.dashboardTab && onTabChange) {
      // Если это вкладка дашборда, переключаем вкладку
      onTabChange(item.dashboardTab);
      // Переходим на дашборд, если не там
      if (location.pathname !== '/dashboard') {
        navigate('/dashboard');
      }
    } else {
      // Обычная навигация
      navigate(item.path);
    }
  };

  const isActive = (item: NavItem) => {
    // Если передан activeTab, используем его
    if (activeTab !== undefined && item.dashboardTab) {
      return activeTab === item.dashboardTab;
    }
    
    if (item.dashboardTab) {
      // Для вкладок дашборда проверяем, что мы на дашборде
      return location.pathname === '/dashboard';
    }
    return location.pathname === item.path;
  };

  return (
    <nav className={`bottom-navigation ${className}`}>
      {navItems.map((item) => (
        <button
          key={item.id}
          className={`nav-item ${isActive(item) ? 'active' : ''}`}
          onClick={() => handleNavClick(item)}
          aria-label={item.label}
        >
          <div className="nav-icon">
            <i className={item.icon}></i>
            {item.badge && item.badge > 0 && (
              <span className="nav-badge">{item.badge}</span>
            )}
          </div>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNavigation;
